export function GlobalLoadingFallback() {
  return (
    <div className="flex min-h-[calc(100vh-10rem)] items-center justify-center">
      <div className="flex flex-col items-center gap-6">
        <div className="flex items-center gap-1.5">
          <span
            className="h-2 w-2 rounded-full bg-primary animate-pulse"
            style={{ animationDelay: '0ms', animationDuration: '1s' }}
          />
          <span
            className="h-2 w-2 rounded-full bg-primary animate-pulse"
            style={{ animationDelay: '150ms', animationDuration: '1s' }}
          />
          <span
            className="h-2 w-2 rounded-full bg-primary animate-pulse"
            style={{ animationDelay: '300ms', animationDuration: '1s' }}
          />
        </div>
      </div>
    </div>
  );
}
